import {
  Box,
  Text,
  ToastPosition,
  useBreakpointValue,
  useToast,
  UseToastOptions,
} from '@chakra-ui/react';
import { useState, useCallback } from 'react';

const useLoaderOverlay = () => {
  const [overlayLoading, setLoading] = useState(false);

  const showOverlay = useCallback(() => setLoading(true), []);
  const hideOverlay = useCallback(() => setLoading(false), []);

  return {
    overlayLoading,
    showOverlay,
    hideOverlay,
  };
};

export default useLoaderOverlay;

const useResponsiveToastPosition = () => {
  return (
    useBreakpointValue<ToastPosition>({
      base: 'bottom',
      tabletSmall: 'top-right',
    }) || 'top-right'
  );
};

export const useToastMessage = () => {
  const toast = useToast();
  const position = useResponsiveToastPosition();

  const showSuccessMessage = (message: string, description: string = '') => {
    toast.closeAll();
    toast({
      title: message,
      description: description,
      status: 'success',
      duration: 5000,
      isClosable: true,
      position,
    });
  };

  const showErrorMessage = (message: string, description: string = '') => {
    toast.closeAll();
    toast({
      title: message,
      description: description,
      status: 'error',
      duration: 5000,
      isClosable: true,
      position,
    });
  };

  const showToastMessage = (message: string) => {
    toast.closeAll();
    toast({
      title: message,
      description: '',
      duration: 2000,
      isClosable: false,
      position,
      icon: null,
      render: () => (
        <Box color="white" p={3} bg="gray.700" borderRadius="md">
          <Text textAlign="center">{message}</Text>
        </Box>
      ),
    });
  };

  return { showSuccessMessage, showErrorMessage, showToastMessage };
};

export const selectedTabStyle = {
  color: 'primary.500',
  borderBottom: '2px solid',
  borderColor: 'primary.500',
};

export const tabStyle = {
  color: 'inactive',
  fontWeight: '500',
  fontSize: '14px',
  p: '0',
};

export const tabLinkStyle = {
  width: '100%',
  height: '100%',
  display: 'block',
  pt: '8px',
  pb: '14px',
};

export const tabIndicatorStyle = {
  mt: '-1.5px',
  height: '2px',
  bg: 'primary.500',
};

export const tabBackground = { base: 'background', tabletSmall: 'white' };

export const tabBorder = { base: 'none', tabletSmall: '1px solid' };

export const tabBorderColor = { base: 'none', tabletSmall: 'gray.100' };

export const getAvatarColor = (index: number): string => {
  const colorList: string[] = [
    'orange.400',
    'blue.400',
    'purple.400',
    'green.400',
    'pink.400',
  ];

  const selectedIndex =
    index >= colorList.length ? index % colorList.length : index;

  return colorList[selectedIndex];
};

export const mobileModalStyle = {
  position: 'fixed',
  bottom: '0',
  marginBottom: '0',
  borderRadius: '15px 15px 0 0',
  maxWidth: '600px',
  width: '100vw',
  maxHeight: '80vh',
  // overflowY: 'auto',
};
